import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _68502d40 = () => interopDefault(import('../public/pages/api-doc.vue' /* webpackChunkName: "pages/api-doc" */))
const _7fc28410 = () => interopDefault(import('../public/pages/applications.vue' /* webpackChunkName: "pages/applications" */))
const _436dc162 = () => interopDefault(import('../public/pages/catalogs.vue' /* webpackChunkName: "pages/catalogs" */))
const _7b58a360 = () => interopDefault(import('../public/pages/datasets.vue' /* webpackChunkName: "pages/datasets" */))
const _f74b1032 = () => interopDefault(import('../public/pages/department.vue' /* webpackChunkName: "pages/department" */))
const _8c7207a6 = () => interopDefault(import('../public/pages/me.vue' /* webpackChunkName: "pages/me" */))
const _3c7e5644 = () => interopDefault(import('../public/pages/new-application.vue' /* webpackChunkName: "pages/new-application" */))
const _cbe8c9f4 = () => interopDefault(import('../public/pages/new-dataset.vue' /* webpackChunkName: "pages/new-dataset" */))
const _7174493a = () => interopDefault(import('../public/pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _52047e08 = () => interopDefault(import('../public/pages/organization.vue' /* webpackChunkName: "pages/organization" */))
const _3b308d40 = () => interopDefault(import('../public/pages/remote-services.vue' /* webpackChunkName: "pages/remote-services" */))
const _4180bb78 = () => interopDefault(import('../public/pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _59c383f6 = () => interopDefault(import('../public/pages/share-dataset.vue' /* webpackChunkName: "pages/share-dataset" */))
const _7e98edb6 = () => interopDefault(import('../public/pages/storage.vue' /* webpackChunkName: "pages/storage" */))
const _bf6c361c = () => interopDefault(import('../public/pages/subscription.vue' /* webpackChunkName: "pages/subscription" */))
const _2cef8489 = () => interopDefault(import('../public/pages/update-dataset.vue' /* webpackChunkName: "pages/update-dataset" */))
const _d76e102e = () => interopDefault(import('../public/pages/admin/base-apps.vue' /* webpackChunkName: "pages/admin/base-apps" */))
const _57121b00 = () => interopDefault(import('../public/pages/admin/errors.vue' /* webpackChunkName: "pages/admin/errors" */))
const _31459bfa = () => interopDefault(import('../public/pages/admin/info.vue' /* webpackChunkName: "pages/admin/info" */))
const _16c3ad35 = () => interopDefault(import('../public/pages/admin/owners.vue' /* webpackChunkName: "pages/admin/owners" */))
const _1902f809 = () => interopDefault(import('../public/pages/embed/workflow/update-dataset.vue' /* webpackChunkName: "pages/embed/workflow/update-dataset" */))
const _7c95fd4d = () => interopDefault(import('../public/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3b202240 = () => interopDefault(import('../public/pages/embed/application/_id.vue' /* webpackChunkName: "pages/embed/application/_id" */))
const _4e8cb9a1 = () => interopDefault(import('../public/pages/embed/application/_id/config.vue' /* webpackChunkName: "pages/embed/application/_id/config" */))
const _2b5d87e8 = () => interopDefault(import('../public/pages/embed/dataset/_id.vue' /* webpackChunkName: "pages/embed/dataset/_id" */))
const _4a843535 = () => interopDefault(import('../public/pages/embed/dataset/_id/calendar.vue' /* webpackChunkName: "pages/embed/dataset/_id/calendar" */))
const _73e2b6d1 = () => interopDefault(import('../public/pages/embed/dataset/_id/extend.vue' /* webpackChunkName: "pages/embed/dataset/_id/extend" */))
const _a9d4a82c = () => interopDefault(import('../public/pages/embed/dataset/_id/extend/_service/_action.vue' /* webpackChunkName: "pages/embed/dataset/_id/extend/_service/_action" */))
const _04068ef0 = () => interopDefault(import('../public/pages/embed/dataset/_id/fields.vue' /* webpackChunkName: "pages/embed/dataset/_id/fields" */))
const _45f51b3b = () => interopDefault(import('../public/pages/embed/dataset/_id/form.vue' /* webpackChunkName: "pages/embed/dataset/_id/form" */))
const _3334d010 = () => interopDefault(import('../public/pages/embed/dataset/_id/journal.vue' /* webpackChunkName: "pages/embed/dataset/_id/journal" */))
const _1a613435 = () => interopDefault(import('../public/pages/embed/dataset/_id/map.vue' /* webpackChunkName: "pages/embed/dataset/_id/map" */))
const _a9e2d306 = () => interopDefault(import('../public/pages/embed/dataset/_id/map-bounds.vue' /* webpackChunkName: "pages/embed/dataset/_id/map-bounds" */))
const _637429be = () => interopDefault(import('../public/pages/embed/dataset/_id/publications.vue' /* webpackChunkName: "pages/embed/dataset/_id/publications" */))
const _7446dc50 = () => interopDefault(import('../public/pages/embed/dataset/_id/schema.vue' /* webpackChunkName: "pages/embed/dataset/_id/schema" */))
const _713dbe89 = () => interopDefault(import('../public/pages/embed/dataset/_id/search-files.vue' /* webpackChunkName: "pages/embed/dataset/_id/search-files" */))
const _ce2c9532 = () => interopDefault(import('../public/pages/embed/dataset/_id/table.vue' /* webpackChunkName: "pages/embed/dataset/_id/table" */))
const _2d6cf560 = () => interopDefault(import('../public/pages/embed/dataset/_id/table-edit.vue' /* webpackChunkName: "pages/embed/dataset/_id/table-edit" */))
const _10a4debe = () => interopDefault(import('../public/pages/embed/dataset/_id/thumbnails.vue' /* webpackChunkName: "pages/embed/dataset/_id/thumbnails" */))
const _57c3e835 = () => interopDefault(import('../public/pages/embed/storage/_type/_id.vue' /* webpackChunkName: "pages/embed/storage/_type/_id" */))
const _095a46e3 = () => interopDefault(import('../public/pages/embed/settings/_type/_id/api-keys.vue' /* webpackChunkName: "pages/embed/settings/_type/_id/api-keys" */))
const _09d61024 = () => interopDefault(import('../public/pages/embed/settings/_type/_id/licenses.vue' /* webpackChunkName: "pages/embed/settings/_type/_id/licenses" */))
const _f3287680 = () => interopDefault(import('../public/pages/embed/settings/_type/_id/topics.vue' /* webpackChunkName: "pages/embed/settings/_type/_id/topics" */))
const _632d7778 = () => interopDefault(import('../public/pages/embed/settings/_type/_id/webhooks.vue' /* webpackChunkName: "pages/embed/settings/_type/_id/webhooks" */))
const _e4ef5d10 = () => interopDefault(import('../public/pages/admin-extra/_id.vue' /* webpackChunkName: "pages/admin-extra/_id" */))
const _0a902ab9 = () => interopDefault(import('../public/pages/application/_id/index.vue' /* webpackChunkName: "pages/application/_id/index" */))
const _105e0fff = () => interopDefault(import('../public/pages/catalog/_id.vue' /* webpackChunkName: "pages/catalog/_id" */))
const _12550f6c = () => interopDefault(import('../public/pages/catalog/_id/description.vue' /* webpackChunkName: "pages/catalog/_id/description" */))
const _16281d61 = () => interopDefault(import('../public/pages/dataset/_id/index.vue' /* webpackChunkName: "pages/dataset/_id/index" */))
const _b5ddac94 = () => interopDefault(import('../public/pages/extra/_id.vue' /* webpackChunkName: "pages/extra/_id" */))
const _ec81e71e = () => interopDefault(import('../public/pages/remote-service/_id/index.vue' /* webpackChunkName: "pages/remote-service/_id/index" */))
const _6074afac = () => interopDefault(import('../public/pages/application/_id/api-doc.vue' /* webpackChunkName: "pages/application/_id/api-doc" */))
const _4f1cc66b = () => interopDefault(import('../public/pages/application/_id/config.vue' /* webpackChunkName: "pages/application/_id/config" */))
const _c7c9acba = () => interopDefault(import('../public/pages/application/_id/description.vue' /* webpackChunkName: "pages/application/_id/description" */))
const _344acf58 = () => interopDefault(import('../public/pages/dataset/_id/api-doc.vue' /* webpackChunkName: "pages/dataset/_id/api-doc" */))
const _94e7036a = () => interopDefault(import('../public/pages/dataset/_id/description.vue' /* webpackChunkName: "pages/dataset/_id/description" */))
const _611bf938 = () => interopDefault(import('../public/pages/remote-service/_id/api-doc.vue' /* webpackChunkName: "pages/remote-service/_id/api-doc" */))
const _3f503d4a = () => interopDefault(import('../public/pages/remote-service/_id/description.vue' /* webpackChunkName: "pages/remote-service/_id/description" */))
const _0630cf6f = () => interopDefault(import('../public/pages/_dev/char-sizes.vue' /* webpackChunkName: "pages/_dev/char-sizes" */))
const _0559fe2c = () => interopDefault(import('../public/pages/_dev/extra.vue' /* webpackChunkName: "pages/_dev/extra" */))
const _b4051e94 = () => interopDefault(import('../public/pages/_dev/extra2.vue' /* webpackChunkName: "pages/_dev/extra2" */))
const _b3e8ef92 = () => interopDefault(import('../public/pages/_dev/extra3.vue' /* webpackChunkName: "pages/_dev/extra3" */))
const _7512a394 = () => interopDefault(import('../public/pages/_dev/table-embed.vue' /* webpackChunkName: "pages/_dev/table-embed" */))
const _cc1675f0 = () => interopDefault(import('../public/pages/_dev/update-dataset.vue' /* webpackChunkName: "pages/_dev/update-dataset" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/data-fair/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/api-doc",
    component: _68502d40,
    name: "api-doc"
  }, {
    path: "/applications",
    component: _7fc28410,
    name: "applications"
  }, {
    path: "/catalogs",
    component: _436dc162,
    name: "catalogs"
  }, {
    path: "/datasets",
    component: _7b58a360,
    name: "datasets"
  }, {
    path: "/department",
    component: _f74b1032,
    name: "department"
  }, {
    path: "/me",
    component: _8c7207a6,
    name: "me"
  }, {
    path: "/new-application",
    component: _3c7e5644,
    name: "new-application"
  }, {
    path: "/new-dataset",
    component: _cbe8c9f4,
    name: "new-dataset"
  }, {
    path: "/notifications",
    component: _7174493a,
    name: "notifications"
  }, {
    path: "/organization",
    component: _52047e08,
    name: "organization"
  }, {
    path: "/remote-services",
    component: _3b308d40,
    name: "remote-services"
  }, {
    path: "/settings",
    component: _4180bb78,
    name: "settings"
  }, {
    path: "/share-dataset",
    component: _59c383f6,
    name: "share-dataset"
  }, {
    path: "/storage",
    component: _7e98edb6,
    name: "storage"
  }, {
    path: "/subscription",
    component: _bf6c361c,
    name: "subscription"
  }, {
    path: "/update-dataset",
    component: _2cef8489,
    name: "update-dataset"
  }, {
    path: "/admin/base-apps",
    component: _d76e102e,
    name: "admin-base-apps"
  }, {
    path: "/admin/errors",
    component: _57121b00,
    name: "admin-errors"
  }, {
    path: "/admin/info",
    component: _31459bfa,
    name: "admin-info"
  }, {
    path: "/admin/owners",
    component: _16c3ad35,
    name: "admin-owners"
  }, {
    path: "/embed/workflow/update-dataset",
    component: _1902f809,
    name: "embed-workflow-update-dataset"
  }, {
    path: "/",
    component: _7c95fd4d,
    name: "index"
  }, {
    path: "/embed/application/:id?",
    component: _3b202240,
    name: "embed-application-id",
    children: [{
      path: "config",
      component: _4e8cb9a1,
      name: "embed-application-id-config"
    }]
  }, {
    path: "/embed/dataset/:id?",
    component: _2b5d87e8,
    name: "embed-dataset-id",
    children: [{
      path: "calendar",
      component: _4a843535,
      name: "embed-dataset-id-calendar"
    }, {
      path: "extend",
      component: _73e2b6d1,
      name: "embed-dataset-id-extend",
      children: [{
        path: ":service?/:action?",
        component: _a9d4a82c,
        name: "embed-dataset-id-extend-service-action"
      }]
    }, {
      path: "fields",
      component: _04068ef0,
      name: "embed-dataset-id-fields"
    }, {
      path: "form",
      component: _45f51b3b,
      name: "embed-dataset-id-form"
    }, {
      path: "journal",
      component: _3334d010,
      name: "embed-dataset-id-journal"
    }, {
      path: "map",
      component: _1a613435,
      name: "embed-dataset-id-map"
    }, {
      path: "map-bounds",
      component: _a9e2d306,
      name: "embed-dataset-id-map-bounds"
    }, {
      path: "publications",
      component: _637429be,
      name: "embed-dataset-id-publications"
    }, {
      path: "schema",
      component: _7446dc50,
      name: "embed-dataset-id-schema"
    }, {
      path: "search-files",
      component: _713dbe89,
      name: "embed-dataset-id-search-files"
    }, {
      path: "table",
      component: _ce2c9532,
      name: "embed-dataset-id-table"
    }, {
      path: "table-edit",
      component: _2d6cf560,
      name: "embed-dataset-id-table-edit"
    }, {
      path: "thumbnails",
      component: _10a4debe,
      name: "embed-dataset-id-thumbnails"
    }]
  }, {
    path: "/embed/storage/:type?/:id?",
    component: _57c3e835,
    name: "embed-storage-type-id"
  }, {
    path: "/embed/settings/:type?/:id?/api-keys",
    component: _095a46e3,
    name: "embed-settings-type-id-api-keys"
  }, {
    path: "/embed/settings/:type?/:id?/licenses",
    component: _09d61024,
    name: "embed-settings-type-id-licenses"
  }, {
    path: "/embed/settings/:type?/:id?/topics",
    component: _f3287680,
    name: "embed-settings-type-id-topics"
  }, {
    path: "/embed/settings/:type?/:id?/webhooks",
    component: _632d7778,
    name: "embed-settings-type-id-webhooks"
  }, {
    path: "/admin-extra/:id?",
    component: _e4ef5d10,
    name: "admin-extra-id"
  }, {
    path: "/application/:id",
    component: _0a902ab9,
    name: "application-id"
  }, {
    path: "/catalog/:id?",
    component: _105e0fff,
    name: "catalog-id",
    children: [{
      path: "description",
      component: _12550f6c,
      name: "catalog-id-description"
    }]
  }, {
    path: "/dataset/:id",
    component: _16281d61,
    name: "dataset-id"
  }, {
    path: "/extra/:id?",
    component: _b5ddac94,
    name: "extra-id"
  }, {
    path: "/remote-service/:id",
    component: _ec81e71e,
    name: "remote-service-id"
  }, {
    path: "/application/:id?/api-doc",
    component: _6074afac,
    name: "application-id-api-doc"
  }, {
    path: "/application/:id?/config",
    component: _4f1cc66b,
    name: "application-id-config"
  }, {
    path: "/application/:id?/description",
    component: _c7c9acba,
    name: "application-id-description"
  }, {
    path: "/dataset/:id?/api-doc",
    component: _344acf58,
    name: "dataset-id-api-doc"
  }, {
    path: "/dataset/:id?/description",
    component: _94e7036a,
    name: "dataset-id-description"
  }, {
    path: "/remote-service/:id?/api-doc",
    component: _611bf938,
    name: "remote-service-id-api-doc"
  }, {
    path: "/remote-service/:id?/description",
    component: _3f503d4a,
    name: "remote-service-id-description"
  }, {
    path: "/:dev/char-sizes",
    component: _0630cf6f,
    name: "dev-char-sizes"
  }, {
    path: "/:dev/extra",
    component: _0559fe2c,
    name: "dev-extra"
  }, {
    path: "/:dev/extra2",
    component: _b4051e94,
    name: "dev-extra2"
  }, {
    path: "/:dev/extra3",
    component: _b3e8ef92,
    name: "dev-extra3"
  }, {
    path: "/:dev/table-embed",
    component: _7512a394,
    name: "dev-table-embed"
  }, {
    path: "/:dev/update-dataset",
    component: _cc1675f0,
    name: "dev-update-dataset"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
